import { ActionIcon, Popover, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

interface InfoNoteProps {
  /** Read out to screen readers in place of the icon. */
  label: string;
  children: string;
}

/**
 * The reasoning behind a number, one interaction away.
 *
 * These screens carry a lot of argument — why a rung is defined the way it is,
 * why a denominator is not what it looks like. Printed in full it out-masses
 * the figures it explains, but deleting it would leave numbers nobody can
 * check. A popover rather than a tooltip: hover-only would put it out of reach
 * on a touchscreen, and this text is long enough to want to stay open.
 */
export function InfoNote({ label, children }: InfoNoteProps) {
  return (
    <Popover width={320} position="top-end" withArrow shadow="md">
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          radius="xl"
          aria-label={label}
        >
          <IconInfoCircle size={15} stroke={1.7} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="xs" c="dimmed">
          {children}
        </Text>
      </Popover.Dropdown>
    </Popover>
  );
}
